/**
 * Plan Duration 計算ロジック
 *
 * 背景: 日曜チェックイン → 平日に留学体験 → 土曜チェックアウト
 * 1週間あたり土日2日が宿泊のみ
 *
 * 例: 留学5日→宿泊6泊(1週間), 留学10日→宿泊13泊(2週間), 留学15日→宿泊20泊(3週間)
 */

/**
 * 留学日数から宿泊日数を計算
 * @param {number|null|undefined} programDays
 * @returns {number|null}
 */
export function calculateStayNights(programDays) {
  if (programDays == null || programDays <= 0) return null

  const weekends = Math.floor((programDays - 1) / 5)
  return programDays + 1 + weekends * 2
}

/**
 * 留学日数からプラン名用表示名（日本語）を生成
 * @param {number|null|undefined} programDays
 * @param {number|null} stayNights
 * @returns {string}
 */
export function generateDisplayName(programDays, stayNights) {
  if (programDays == null || programDays <= 0) return ''

  if (programDays <= 4) return `${stayNights}泊`

  const weeks = Math.floor(programDays / 5)
  return `${weeks}週間`
}

/**
 * 留学日数からプラン名用表示名（英語）を生成
 * @param {number|null|undefined} programDays
 * @param {number|null} stayNights
 * @returns {string}
 */
export function generateDisplayNameEn(programDays, stayNights) {
  if (programDays == null || programDays <= 0) return ''

  if (programDays <= 4) return `${stayNights} nights`

  const weeks = Math.floor(programDays / 5)
  return weeks === 1 ? '1 week' : `${weeks} weeks`
}

/**
 * 宿なしプラン（School Fee Only）の留学期間の終了日を計算する。
 *
 * 留学日数(programDays)は「平日（土日を除く）」で数えるため、開始日（チェックイン日）から
 * 数えて programDays 個目の平日を終了日として返す。単純な「開始日 +(programDays - 1)日」では
 * 週末を跨いだ分だけ終了日が早まってしまう（例: programDays=10 を 8/24(月) → 誤 9/2 / 正 9/4）。
 *
 * バックエンド app/models/check_in_date.rb#program_weekdays / end_date_for_summary と同一規則
 * （祝日は無視し、土日のみスキップ）。
 *
 * 例: programDays=20 を 2026-08-03(月) から数えると 2026-08-28(金)。
 *
 * @param {Date} startDate チェックイン日
 * @param {number|string|null|undefined} programDays 留学日数（平日カウント）
 * @returns {Date} programDays 個目の平日の Date。programDays<=0 の場合は startDate と同日（帯なし）。
 */
export function programEndDate(startDate, programDays) {
  const count = parseInt(programDays, 10) || 0
  const date = new Date(startDate)
  if (count <= 0) return date

  let weekdays = 0
  // 平日 count 個は最大でも count*2+7 日以内に必ず出現する（無限ループ防止のガード）。
  const maxDays = count * 2 + 7
  for (let i = 0; i < maxDays; i += 1) {
    const dayOfWeek = date.getDay() // 0=日曜, 6=土曜
    if (dayOfWeek !== 0 && dayOfWeek !== 6) {
      weekdays += 1
      if (weekdays === count) return date
    }
    date.setDate(date.getDate() + 1)
  }
  return date
}
